import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";

const name = "marketerPipeline";
const baseUrl = `${process.env.REACT_APP_API_URL}/api/ManagePipeline/marketer/manage-pipelines`;

const checkResponse = (response) => {
  const { Succeeded, Errors, Message: message } = response;
  if (!Succeeded && Errors?.length) throw new Error(message);
  return response;
};

// Get all marketer pipelines
export const getMarketerPipelinesApi = createAsyncThunk(
  `${name}/getPipelines`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(fetchWrapper.get(baseUrl));
      return checkResponse(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Create a new marketer pipeline
export const createMarketerPipelineApi = createAsyncThunk(
  `${name}/createPipeline`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/create`, payload)
      );
      return checkResponse(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Update an existing marketer pipeline
export const updateMarketerPipelineApi = createAsyncThunk(
  `${name}/updatePipeline`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/update`, payload)
      );
      return checkResponse(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Delete one or more marketer pipelines
export const deleteMarketerPipelinesApi = createAsyncThunk(
  `${name}/deletePipelines`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.delete(`${baseUrl}/delete`, payload)
      );
      return checkResponse(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
